import {
    ZoomInOutlined,
} from '@ant-design/icons';
import {Popover} from 'antd';
import cn from 'classnames';
import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {TTableHeaderStructure} from 'components/report-configuration/tabs/report-table-settings/modals/excel-header-structure-loader-modal/excel-header-structure-loader-modal.types';
import './table-row-drillup.less';
import {TEntity} from 'modules/data';
import {TTableReportColumn} from 'store/slices/table-report-slice/table-report-slice-types';

import {ITableReportColumnProps} from '../table-report-columns/table-report-columns';
import {ITableReportProps} from '../table-report-types';
import {TableRowDrillUpContent} from './components/table-row-drillup-content';

interface ITableRowDrillUpProps {
    rowRecord?: TEntity;
    headerStructure: TTableHeaderStructure | undefined;
    columns: TTableReportColumn[] | undefined;
    columnProps: ITableReportColumnProps;
    docId: ITableReportProps['docId'];
}

export const TableRowDrillUp: FC<ITableRowDrillUpProps> = (
    {
        rowRecord,
        headerStructure,
        columns,
        columnProps,
        docId,
    }: ITableRowDrillUpProps,
) => (
    <div className={cn('table-row-drillup')}>
        <ModalOpenerComponent
            modalProps={{
                centered: true,
                title: 'Результаты Drill Up',
                destroyOnClose: true,
                forceRender: false,
                width: '100%',
            }}
            hideControls={{
                all: true,
            }}
            componentWrapperClassNames="align-items-center"
            component={(
                <>
                    <Popover
                        placement="bottomRight"
                        mouseEnterDelay={1}
                        content={(
                            <div>
                                Drill Up
                            </div>
                        )}
                    >
                        <div className={cn(
                            'table-row-drillup__row-control',
                        )}
                        >
                            <ZoomInOutlined />
                        </div>
                    </Popover>
                </>
            )}
        >
            <TableRowDrillUpContent
                rowRecord={rowRecord!}
                headerStructure={headerStructure}
                columns={columns}
                columnProps={columnProps}
                docId={docId}
            />
        </ModalOpenerComponent>
    </div>
);
